import React from 'react';
import ZsFormikCheckbox from "src/components/atoms/zsCheckbox";
import {useField} from "formik";

export interface IEnergyTypeElectricityProps {
    gasPossible: boolean;
    disableAutoselect: boolean;
    disabled: boolean;
}

export function EnergyTypeElectricity(props: IEnergyTypeElectricityProps) {

    const [{value}, __, {setValue}] = useField('energyTypeElectricity');

    React.useEffect(() => {
        if (props.disableAutoselect) {
            return;
        }
        if (!props.gasPossible) {
            setValue(true);
        } else {
            setValue(false);
        }

    }, [props.gasPossible]);

    return (
        <ZsFormikCheckbox label="Strom" name="energyTypeElectricity" disabled={props.disabled}/>
    );

}